export type PhoneNumber = {
  countryCode: string;
  prefix: string;
  number: string;
};
